import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo } from 'react';
import { CartSuccessModal, CartSuccessModalProps } from '@udemy-v2/react-cart-success-modal';
import { withPriceEventTrackingContext } from '@/features/course-landing-page/events/with-price-event-tracking-context';
import { useClpVoucherContext } from '@/features/course-landing-page/context/voucher-context.react-component';
import { useFeatures } from '@udemy-v2/react-experimentation';
import { publishEvent } from '@udemy-v2/event-tracking';
import { ExperimentImpressionEvent } from '@udemy-v2/react-experimentation';
const InternalCartSuccessModal = props => {
  const $ = _c(18);
  const {
    certificationVoucher,
    certificationTopicId,
    bundledCertificationCourses
  } = useClpVoucherContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["cert_bundles_in_clp_fbt_modal"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    featureVariantAssignments: features
  } = useFeatures(t0);
  let t1;
  if ($[1] !== features) {
    t1 = features.get("cert_bundles_in_clp_fbt_modal");
    $[1] = features;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const showCertBundleFeature = t1;
  let t2;
  bb0: {
    const fbtModalCertBundleVariant = showCertBundleFeature?.configuration?.fbtModalCertBundleVariant ?? "HIDDEN";
    if (fbtModalCertBundleVariant === "HIDDEN") {
      t2 = undefined;
      break bb0;
    }
    if (certificationVoucher) {
      const t3 = certificationTopicId ?? undefined;
      let t4;
      if ($[3] !== bundledCertificationCourses || $[4] !== certificationVoucher || $[5] !== t3) {
        t4 = {
          certificationTopicId: t3,
          bundledCertificationCourses,
          certificationVoucher
        };
        $[3] = bundledCertificationCourses;
        $[4] = certificationVoucher;
        $[5] = t3;
        $[6] = t4;
      } else {
        t4 = $[6];
      }
      t2 = t4;
    } else {
      t2 = undefined;
    }
  }
  const certificationData = t2;
  let t3;
  if ($[7] !== certificationVoucher || $[8] !== showCertBundleFeature?.experimentIds || $[9] !== showCertBundleFeature?.isLocalDefault) {
    t3 = () => {
      if (certificationVoucher) {
        publishEvent(new ExperimentImpressionEvent({
          experimentIds: showCertBundleFeature?.experimentIds ?? [],
          isLocalDefaultShown: showCertBundleFeature?.isLocalDefault ?? false
        }));
      }
    };
    $[7] = certificationVoucher;
    $[8] = showCertBundleFeature?.experimentIds;
    $[9] = showCertBundleFeature?.isLocalDefault;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  showCertBundleFeature?.experimentIds;
  showCertBundleFeature?.isLocalDefault;
  const emitVoucherExperimentImpression = t3;
  const t4 = showCertBundleFeature?.configuration?.fbtModalCertBundleVariant === "ALACARTE";
  let t5;
  if ($[11] !== t4) {
    t5 = {
      aLaCarte: t4
    };
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== certificationData || $[14] !== emitVoucherExperimentImpression || $[15] !== props || $[16] !== t5) {
    t6 = <CartSuccessModal {...props} onOpen={emitVoucherExperimentImpression} certificationData={certificationData} options={t5} />;
    $[13] = certificationData;
    $[14] = emitVoucherExperimentImpression;
    $[15] = props;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};

/**
 * CartSuccessModal wrapped with price event tracking context.
 * This ensures all pricing events triggered within the modal have the 'cartSuccessModal' context.
 */
export const ClpCartSuccessModal = withPriceEventTrackingContext(InternalCartSuccessModal, {
  context: 'cartSuccessModal'
});